import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
@Injectable()
export class FormHelper {
  constructor() { }

  public unsubscription(component: any) {
    for (let propertyName in component) {
      const propertyValue = component[propertyName];
      if (propertyValue && typeof propertyValue['unsubscribe'] === 'function') {
        propertyValue.unsubscribe();
      }
    }
  }

  public markFormGroupDirty(form: UntypedFormGroup) {
    Object.values(form.controls).forEach(control => {
      control.markAsDirty();

      if ((control as any).controls) {
        this.markFormGroupDirty(control as UntypedFormGroup);
      }
    });
  }

  public updateFormGroupValidity(form: UntypedFormGroup) {
    Object.values(form.controls).forEach(control => {
      control.updateValueAndValidity();

      if ((control as any).controls) {
        this.updateFormGroupValidity(control as UntypedFormGroup);
      }
    });
  }

  public disable(form: UntypedFormGroup) {
    Object.values(form.controls).forEach(control => {
      control.disable();

      if ((control as any).controls) {
        this.disable(control as UntypedFormGroup);
      }
    });
  }

  public enable(form: UntypedFormGroup) {
    Object.values(form.controls).forEach(control => {
      control.enable();

      if ((control as any).controls) {
        this.enable(control as UntypedFormGroup);
      }
    });
  }
}
